import styled from 'styled-components';
import {ButtonPrimary} from 'components/buttons';

export const AvatarWrapper = styled.div`
  position: relative;
  flex: 0 0 ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`;

export const AvatarCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;

  &.sidebar {
    background-color: #3b3f4a;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
  }

  &.help {
    background-color: #ffe5e7;
    color: #b3121f;
    font-size: 20px;
  }
`;

export const AvatarBadge = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #ff2d38;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  line-height: 1;

  &.sidebar {
    right: -3px;
    bottom: -3px;
    width: 13px;
    height: 13px;
    border: 2px solid #252830;
    font-size: 7px;
  }

  &.help {
    right: -2px;
    bottom: -2px;
    width: 22px;
    height: 22px;
    border: 3px solid #ffffff;
    font-size: 12px;
  }
`;

// Sidebar row
export const SidebarSuccessManagerSection = styled.div`
  padding: 10px 14px;
  border-top: 1px solid #333;
  position: relative;
  z-index: 2;
  background-color: #1a1d23;
  font-family: 'Poppins', sans-serif;
`;

export const SidebarSuccessManagerLabel = styled.div`
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #888;
  margin: 0 2px 8px;
`;

export const SidebarSuccessManagerCard = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 10px;
  background-color: #252830;
`;

export const SidebarSuccessManagerInfo = styled.div`
  flex-grow: 1;
  min-width: 0;
`;

export const SidebarSuccessManagerName = styled.div`
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SidebarSuccessManagerRole = styled.div`
  margin-top: 3px;
  font-size: 9px;
  line-height: 1;
  color: #888;
`;

export const SidebarSuccessManagerEmail = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background-color: #33363f;
  color: #ffffff;

  &:hover {
    color: #ffffff;
  }
`;

// Help page card
export const SuccessManagerHelpCard = styled.section`
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 8px 16px 0px rgba(221, 221, 221, 0.32);
  padding: 20px 16px;
  font-family: 'Poppins', sans-serif;
`;

export const SuccessManagerHelpInfo = styled.div`
  flex: 1 1 320px;
  min-width: 0;
`;

export const SuccessManagerEyebrow = styled.div`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #b3121f;
`;

export const SuccessManagerName = styled.h3`
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  color: #000000;
  margin: 2px 0 0;
`;

export const SuccessManagerText = styled.p`
  font-size: 12px;
  line-height: 150%;
  color: #4a4f5c;
  margin: 4px 0 0;
  max-width: 560px;
`;

export const SuccessManagerActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`;

export const SuccessManagerEmailButton = styled(ButtonPrimary)`
  text-decoration: none;

  span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    line-height: 1;
    font-weight: 400;

    svg {
      display: block;
      flex: 0 0 auto;
    }
  }
`;

export const SuccessManagerCopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  color: #1b1d23;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  padding: 15px 26px;
  border-radius: 30px;
  border: 1px solid #d5d8de;
  cursor: pointer;

  svg {
    display: block;
    flex: 0 0 auto;
  }
`;
